import { DataGrid, useGridApiRef,GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from "@mui/material";
import { Project } from "../objects/Project.interface";
import React, { useState } from "react";
import { PropsProjects } from "./Anotador";

import IconButton from '@mui/material/IconButton';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { createNewProject } from "../services/Projects.service";

var projectSelected: Project = createNewProject();

var projectsTmp: Project[] = [];
export default function ProjectList(props: PropsProjects){
    const [open, setOpen] = React.useState(false);
    const [projectToDelete, setProjectoToDelete] = useState(projectSelected);
    const [projects, setProjects] = useState(projectsTmp);
    const apiRef = useGridApiRef();
    const columns: GridColDef[] = [
        {field: 'id'},
        {field: 'name', minWidth: 100},
        {field: 'namespace'},
        {field: 'description', flex: 1, minWidth: 200, maxWidth: 700},
        {field: 'Actions', flex: 0.3, minWidth: 200,
            renderCell: (params: GridRenderCellParams<any, number>) => 
            (
                <div>
                    
                    <IconButton aria-label="Annotator" size="small" color="inherit" onClick={()=>{ var result:Project|undefined = projects.find((entity) => entity.id == params.id);
                        if(result){
                            props.OpenCorpus(result);
                        }
                    }}>
                        <DashboardIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton aria-label="Edit" size="small" color="inherit" onClick={()=>{ var result:Project|undefined = projects.find((entity) => entity.id == params.id);
                        if(result){
                            props.OpenDetails(result);
                        }
                    }}>
                        <EditIcon fontSize="inherit" />
                    </IconButton>
                    <IconButton aria-label="Delete Project" size="small" color="error" onClick={()=>{ var result:Project|undefined = projects.find((entity) => entity.id == params.id);
                        if(result){
                                setProjectoToDelete(result);
                                setOpen(true);
                        }
                    }}>
                        <DeleteIcon fontSize="inherit" />
                    </IconButton>
                </div>
            )}
    ];

    if(props.Projects && props.Projects.length != projects.length)
        setProjects(props.Projects);
   
    const handleClose = () => {
        setOpen(false);
        };

    return (
        <div>
            <Dialog
                        open={open}
                        onClose={handleClose}
                        PaperProps={{
                        component: 'form',
                        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
                            event.preventDefault();
                            if(projectToDelete){
                                props.DeleteProject(projectToDelete);
                                handleClose();
                            }
                        },
                        }}
                    >
                        <DialogTitle>Delete Project</DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                            Do you want to delete the project '{projectToDelete.name}' and its related entries? This action cannot be reversed.
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                        <Button onClick={handleClose}>Cancel</Button>
                        <Button type="submit">Delete</Button>
                        </DialogActions>
                    </Dialog>

                    <DataGrid apiRef={apiRef} rows={projects} columns={columns} ></DataGrid>
        </div>
        
    );
}